import Cookies from 'js-cookie';

const FAVORITES_COOKIE_KEY = 'favorite_candidates';

export const getFavoriteCandidates = (): string[] => {
  const favorites = Cookies.get(FAVORITES_COOKIE_KEY);
  return favorites ? JSON.parse(favorites) : [];
};

export const toggleFavoriteCandidate = (candidateId: string): string[] => {
  const favorites = getFavoriteCandidates();
  const newFavorites = favorites.includes(candidateId)
    ? favorites.filter(id => id !== candidateId)
    : [...favorites, candidateId];

  Cookies.set(FAVORITES_COOKIE_KEY, JSON.stringify(newFavorites), {
    expires: 365
  });
  return newFavorites;
};

export const isCandidateFavorite = (candidateId: string): boolean => {
  const favorites = getFavoriteCandidates();
  return favorites.includes(candidateId);
};
